<template>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="translate-y-full opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="translate-y-full opacity-0"
  >
    <div
      v-if="visible"
      class="fixed bottom-0 left-0 right-0 z-[100] bg-white border-t border-gray-200 shadow-2xl"
    >
      <div class="max-w-7xl mx-auto px-4 py-4 md:py-5">
        <div class="flex flex-col md:flex-row items-start md:items-center gap-4">
          <div class="flex-1">
            <h3 class="text-sm font-semibold text-gray-900 mb-1">🍪 Cookie & Privacy Settings</h3>
            <p class="text-sm text-gray-600 leading-relaxed">
              We use cookies to enhance your experience, analyze site traffic, and serve personalized content.
              By clicking "Accept All", you consent to our use of cookies and data processing as described in our
              <router-link to="/privacy" class="text-primary-600 hover:underline font-medium" @click="visible = false">Privacy Policy</router-link>
              and
              <router-link to="/cookies" class="text-primary-600 hover:underline font-medium" @click="visible = false">Cookie Policy</router-link>.
            </p>
          </div>
          <div class="flex flex-wrap items-center gap-2 shrink-0">
            <button
              @click="rejectAll"
              class="px-4 py-2 text-sm text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition"
            >
              Reject All
            </button>
            <button
              @click="acceptEssential"
              class="px-4 py-2 text-sm text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition"
            >
              Essential Only
            </button>
            <button
              @click="acceptAll"
              class="px-4 py-2 text-sm bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { getConsent, setConsent } from '@/utils/cookieConsent'

const visible = ref(false)

onMounted(() => {
  const existing = getConsent()
  if (!existing) {
    visible.value = true
  }
})

function acceptAll() {
  setConsent({
    essential: true,
    analytics: true,
    marketing: true,
    timestamp: new Date().toISOString()
  })
  visible.value = false
}

function acceptEssential() {
  setConsent({
    essential: true,
    analytics: false,
    marketing: false,
    timestamp: new Date().toISOString()
  })
  visible.value = false
}

function rejectAll() {
  setConsent({
    essential: false,
    analytics: false,
    marketing: false,
    timestamp: new Date().toISOString()
  })
  visible.value = false
}
</script>
